import { useQuery, gql } from "@apollo/client";
import React from "react";
import ImgixFluidImage from "./ImgixFluidImage";
import { ASSET_FRAGMENT } from "../../fragments";

const PlaceHolderImage = ({image, ar=3/2 }) => {

    const {loading, error, data} = useQuery(GET_PLACEHOLDER_IMAGE_DATA);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error : {error.message}</p>;

    image = image || data.globalSet.siteImage[0];

    return (
        <ImgixFluidImage image={image} sizes="100vw" ar={ar} focalPoint={image.focalPoint}/>
    );
};

export default PlaceHolderImage;

const GET_PLACEHOLDER_IMAGE_DATA = gql`
    query PlaceHolderImageQuery {
        globalSet(handle: "globals") {
            ... on globals_GlobalSet {
                siteImage {
                    ...AssetFragment
                }
            }
        }
     }

     ${ASSET_FRAGMENT}
`;
